module.exports = __webpack_public_path__ + "img/marks.204fd0fb.jpg";